export { CollectibleSceneInfo } from './CollectibleSceneInfo'
